const sexExclude=
{
male:["cervical","endometrial", "ovarian", "vaginal", "vulval"], 
female:["penile", "prostate", "testicular"],
notChild:["neuroblastoma", "retinoblastoma", "wilms", "childConcern"]
}

export default sexExclude